import { createAction, props } from '@ngrx/store';
import { Ticket, TicketSearchRequest } from '../../../types/interfaces/ticket';
import {
  ChatMessage,
  MessageReactionsAttributes,
} from '../../../types/interfaces/message';
import {
  ChatNewManualConnectionRequest,
  MessageTemplate,
} from '../../../types/interfaces/message-templates';
import { ChatUserAttributes } from '../../../types/interfaces/chat-user';
import { Chat } from '../../../types/interfaces/chat';

export const initialTickets = createAction(
  '[Chats] Initial Chats',
  props<{ chats: Chat[] }>()
);

export const newTicket = createAction(
  '[Chats] New Chat',
  props<{ chat: Chat }>()
);

export const removeTicket = createAction(
  '[Chats] Remove Chat',
  props<{ chatId: number }>()
);

export const updateTicket = createAction(
  '[Chats] Update Chat',
  props<{ chat: Chat }>()
);

export const ticketAssigned = createAction(
  '[Chats] Ticket Assigned',
  props<{ chat: Chat }>()
);

export const selectChat = createAction(
  '[Chats] Select Chat',
  props<{ chat: Chat | undefined }>()
);

export const selectChatMessages = createAction(
  '[Chats] Select Chat Messages',
  props<{ chatId: number; messages: ChatMessage[] }>()
);

export const newMessage = createAction(
  '[Chats] New ChatMessage',
  props<{ idTicket: number; message: ChatMessage }>()
);

export const updateMessage = createAction(
  '[Chats] Update message',
  props<{ message: ChatMessage }>()
);

export const newAgentMessage = createAction(
  '[Chats] New Agent ChatMessage',
  props<{ idTicket: number; message: ChatMessage }>()
);

export const getMessageTemplatesForTicket = createAction(
  '[Chats] Get Message Templates For Ticket',
  props<{ ticketId: number }>()
);

export const getMessageTemplatesForTicketSuccess = createAction(
  '[Chats] Get Message Templates For Ticket Success',
  props<{ messageTemplates: MessageTemplate[] }>()
);

export const loadChatUsers = createAction(
  '[Chats] Load Chat Users',
  props<{ filter?: string }>()
);

export const loadChatUsersSuccess = createAction(
  '[Chats] Load Chat Users Success',
  props<{ users: ChatUserAttributes[] }>()
);

export const getMessageTemplates = createAction(
  '[Chats] Get Message Templates',
  props<{ connectionId: string }>()
);

export const getMessageTemplatesSuccess = createAction(
  '[Chats] Get Message Templates Success',
  props<{ messageTemplates: MessageTemplate[] }>()
);

export const createTicket = createAction(
  '[Chats] Create Ticket',
  props<{ data: ChatNewManualConnectionRequest }>()
);

export const createTicketSuccess = createAction(
  '[Chats] Create Ticket Success',
  props<{ result: any }>()
);

export const clearTicketCreated = createAction(
  '[Chats] Clear Ticket Created'
);

export const getHistoryTickets = createAction(
  '[Chats] Get History Chats',
  props<{ params: TicketSearchRequest }>()
);

export const getHistoryChatsSuccess = createAction(
  '[Chats] Get History Chats Success',
  props<{ chats: Chat[] }>()
);

export const clearSelectedTicket = createAction(
  '[Chats] Clear Selected Ticket]'
);

export const newReaction = createAction(
  '[Chats] New Reaction',
  props<{ idTicket: number; reaction: MessageReactionsAttributes }>()
);

export const setTicketTabActive = createAction(
  '[Chats] Set Ticket Tab Active',
  props<{ tab: 'queue' | 'progress' | 'closed' | 'search' }>()
);
